<div *ngFor="let cl of traps" class="card mb-3">

    <div class="card-header">
        {{cl.name}}
    </div>
    <div class="card-body">
        <app-attribute-store [attributes]="cl.attributes"></app-attribute-store>
    </div>
</div>